module.exports = __webpack_public_path__ + "088cc983d76d1826cd7985698bddde92.png";